import { createContext } from 'react';

export type TrackingInfo = {
  landing_page?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  querystring?: string;

  first_landing_page?: string;
  first_utm_source?: string;
  first_utm_medium?: string;
  first_utm_campaign?: string;
  first_utm_content?: string;
  first_utm_term?: string;
  first_querystring?: string;
}

type ContextState = [TrackingInfo | undefined, React.Dispatch<React.SetStateAction<TrackingInfo | undefined>>];

export const CampaignTrackerContext = createContext<ContextState | null>(null);
